import { create } from "zustand";

interface GlobalStore {
  isGithubExpired: boolean;
  isGitlabExpired: boolean;
  isBitbucketExpired: boolean;

  setGithubExpired: (expired: boolean) => void;
  setGitlabExpired: (expired: boolean) => void;
  setBitbucketExpired: (expired: boolean) => void;
}

export const useGlobalStore = create<GlobalStore>((set, get) => ({
  isGithubExpired: false,
  isGitlabExpired: false,
  isBitbucketExpired: false,

  setGithubExpired: (expired: boolean) => set({ isGithubExpired: expired }),
  setGitlabExpired: (expired: boolean) => set({ isGitlabExpired: expired }),
  setBitbucketExpired: (expired: boolean) =>
    set({ isBitbucketExpired: expired }),
}));
